import { createAmountFormatter } from './formatAmount';

/**
 * Formats an amount in kroner, rounded to whole kroner by default:
 *
 * ```ts
 * formatKr(1000); // '1 000 kr'
 * formatKr(1000.5, { decimals: 2 }); // '1 000,50 kr'
 * formatKr(1000, { signed: true }); // '+ 1 000 kr'
 * ```
 */
export const formatKr = createAmountFormatter({ suffix: 'kr' });
